import { render, staticRenderFns } from "./Atlanta.vue?vue&type=template&id=236c2200&scoped=true&"
import script from "./Atlanta.vue?vue&type=script&lang=js&"
export * from "./Atlanta.vue?vue&type=script&lang=js&"
import style0 from "./Atlanta.vue?vue&type=style&index=0&id=236c2200&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c2200",
  null
  
)

export default component.exports